
import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class UgService {
    constructor(
        private httpService: HttpService) { }

    //登录ug体育
    //TQQ 2018-06-01
    loginUg() {
        let url = AppConfig.GetProdUrl() + "/Ug/LoginUg";
        return this.httpService.get(url);
    }

    //ug转账
    //TQQ 2018-06-04

    transferUg(amount, transferType) {
        let url = transferType == 0 ? AppConfig.GetProdUrl() + "/Ug/TransferToUg" : AppConfig.GetProdUrl() + "/Ug/TransferFromUg";
        let par = { Amount: amount, TransferType: transferType };
        return this.httpService.post(url, par);
    }
    //ar转账
    transferAr(amount, transferType) {
        let url = AppConfig.GetProdUrl() + "/Ag/ForwardGame";
        let par = { Amount: amount, TransferType: transferType };
        return this.httpService.post(url, par);
    }
    //bet
    //TQQ 2018-06-07
    getBetList(params) {
        let url = AppConfig.GetProdUrl() + "/Ug/GetBetList";
        return this.httpService.post(url, params);
    }
    getBetTeamList(params) {
        let url = AppConfig.GetProdUrl() + "/Ug/GetBetTeamList";
        return this.httpService.post(url, params);
    }
    // ug转账记录
    // TQQ 2018-06-15
    getUgTransferList(params) {
        let url = AppConfig.GetProdUrl() + "/Ug/GetUgTransferList";
        return this.httpService.post(url, params);
    }

    //子注单列表
    //TQQ 2018-06-07
    getBetInfoList(params) {
        let url = AppConfig.GetProdUrl() + "/Ug/GetBetInfoList";
        return this.httpService.post(url, params);
    }

    /**
     *跳转AG游戏
     *
     * @memberof UgService
     */
    goAgGame() {
        let url = AppConfig.GetProdUrl() + "/Ag/ForwardGame?gameType=1+&actype=1+&oddtype=A";
        // let url = AppConfig.GetProdUrl() + "Ag/ForwardGame";
        return this.httpService.get(url);
    }
    /**
     *获取AG余额
     *
     * @returns
     * @memberof UgService
     */
    getAgBalance() {
        let url = AppConfig.GetProdUrl() + "/Ag/GetBalance";
        return this.httpService.get(url);
    }

    /**
     *AG转账
     *
     * @param {*} params
     * @returns
     * @memberof UgService
     */
    agTransfer(params) {
        let url = AppConfig.GetProdUrl() + "/Funds/PlatformTransfer";
        return this.httpService.post(url, params);
    }

    getUgBalance() {
        let url = AppConfig.GetProdUrl() + "/Ug/GetUgBalance";
        return this.httpService.post(url, {});
    }
    /**
     * 判断ag是否开启
     */
    agIsOpen() {
        let url = AppConfig.GetProdUrl() + "/Ag/AgisOpen";
        return this.httpService.post(url, {});
    }
    /**
     * UG团队报表
     */
    getUgTeamReport(params) {
        let url = AppConfig.GetProdUrl() + '/Ug/GetUgTeamReportList';
        return this.httpService.post(url, params);
    }
    /**
     * 沙巴体育登录
     * 
     */
    loginShaBa() {
        let url = AppConfig.GetProdUrl() + '/ShaBa/Login';
        return this.httpService.post(url, { Device: 0 });
    }
    // /**
    //  * 转账到沙巴 
    //  * 
    //  */
    // transferToSb(params) {
    //     let url = AppConfig.GetProdUrl() + '/ShaBa/TransferToSb';
    //     return this.httpService.post(url, params);
    // }
    /**
     * 沙巴转账
     * 0转入沙巴，1从沙巴转出
     */
    transferSb(amount, type) {
        let url = type == 0 ? AppConfig.GetProdUrl() + "/ShaBa/TransferToSb" : AppConfig.GetProdUrl() + "/ShaBa/TransferFromSb";
        let par = { Amount: amount, Type: type };
        return this.httpService.post(url, par);
    }
    /**
     * 获取沙巴体育余额
     */
    getShaBaBalance() {
        let url = AppConfig.GetProdUrl() + '/ShaBa/GetBalance';
        return this.httpService.post(url, {});
    }
    /**
     * 获取沙巴体育转账记录
     */
    getShaBaTransferList(params) {
        let url = AppConfig.GetProdUrl() + '/ShaBa/GetTransferList';
        return this.httpService.post(url, params);
    }
    /**
    * 获取沙巴体育投注记录
    */
    getShaBaBettingList(params) {
        let url = AppConfig.GetProdUrl() + '/ShaBa/GetBettingList';
        return this.httpService.post(url, params);
    }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/services/ug.service.ts